import { type ReactNode } from 'react';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { MapLayout } from './internal/components/MapLayout/MapLayout';
import { MapPlaceholderContainer } from './internal/components/MapPlaceholder';
import { ToggleMapButtonContainer } from './internal/components/ToggleMapButton';
import { ToggleMapButtonHintContextProvider } from './internal/context/ToggleMapButtonHintContext';

type MapLayoutProps = {
  map: ReactNode;
};

export function MapLayoutContainer({ map }: MapLayoutProps): ReactNode {
  const isMapOpen = useListingLayoutIsNarrowSelector();

  return (
    <ToggleMapButtonHintContextProvider>
      <MapLayout
        isMapOpen={isMapOpen}
        map={map}
        mapPlaceholder={<MapPlaceholderContainer />}
        toggleComponent={<ToggleMapButtonContainer />}
      />
    </ToggleMapButtonHintContextProvider>
  );
}
